import { useLang } from '@/app/utils/useLang';
import EcoImg from 'eco-design/base/eco-img';
import { AnimatedGrid } from 'elem/compPage/delta-3-max-series/pages/product/us/StatusA/Components/AnimatedSection';
import CommonTitle from 'elem/compPage/delta-3-max-series/pages/product/us/StatusA/Components/CommonTitle';
import styles from './index.module.scss';

const TwoEasy: React.FC = () => {
    const { t } = useLang('TwoEasy');

    const list = [
        {
            title: t.rich('item1_title', {
                sup: (text: string) => <sup>{text}</sup>,
            }),
            desc: t('item1_desc'),
            pc: 'https://websiteoss.ecoflow.com/figma-uploads/1758859085565-yrmkdx-compressed-%E5%A4%A7%E7%94%B5%E7%AE%B1.jpg',
            img: 'https://websiteoss.ecoflow.com/figma-uploads/1757754334402-clc13n-compressed-Frame%201612708225.png',
        },
        {
            title: t('item2_title'),
            desc: t.rich('item2_desc', {
                sup: (text: string) => <sup>{text}</sup>,
            }),
            pc: 'https://websiteoss.ecoflow.com/figma-uploads/1758859114660-wgu5np-compressed-BOX.jpg',
            img: 'https://websiteoss.ecoflow.com/figma-uploads/1757754320641-w88737-compressed-Frame%201612708225.png',
        },
    ];

    return (
        <div className={`page-twoEasy GtmModuleData-section ${styles.TwoEasy}`} id="TwoEasy" data-section-id="d3m-two-easy">
            <CommonTitle title={t('title')} />

            <AnimatedGrid variant="rotateIn" options={{ delay: 200, stagger: 0.15, threshold: 0.2 }} className="eco-content two-easy-container">
                <div className="two-easy-box">
                    {list.map((item, index) => {
                        return (
                            <div className="item" key={index}>
                                <EcoImg className="item-img" pc={item.pc} />
                                <div className="item-content">
                                    <EcoImg className="item-icon" pc={item.img} />
                                    <div className="item-info">
                                        <div className="item-title">{item.title}</div>
                                        <div className="item-desc">{item.desc}</div>
                                    </div>
                                </div>
                            </div>
                        );
                    })}
                </div>
            </AnimatedGrid>
        </div>
    );
};

export default TwoEasy;
